import { gql } from 'apollo-angular';

export const getShoppingListsQuery = gql`
    query getShoppingLists($options: ShoppingListListOptions) {
        getShoppingLists(options: $options) {
            items {
                id
                name
                token
                enabled
                image {
                    id
                    name
                    preview
                }
            }
            totalItems
        }
    }
`;

export const addBulkItemsToShoppingListMutation = gql`
    mutation addBulkItemsToShoppingList(
        $input: AddBulkItemsToShoppingListInput!
    ) {
        addBulkItemsToShoppingList(input: $input) {
            __typename

            ... on AddBulkItemsToShoppingListSuccess {
                success
            }

            ... on AddBulkItemsToShoppingListError {
                message
                errorCode
            }
        }
    }
`;

export const UPDATE_PRODUCTS_BULK = gql`
    mutation UpdateProductsBulk($input: [UpdateProductInput!]!) {
        updateProducts(input: $input) {
            id
            name
            facetValues {
                id
                name
                code
            }
        }
    }
`;
